var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "25px",
    width: "25px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#ffffff;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.909,109.715H31.091C13.929,109.715,0,123.644,0,140.806v213.098c0,26.728,21.653,48.38,48.38,48.38 H463.62c26.728,0,48.38-21.653,48.38-48.38V140.806C512,123.644,498.071,109.715,480.909,109.715z M329.145,158.475h48.76v48.759 h-48.76V158.475z M329.145,231.615h48.76v48.769h-48.76V231.615z M255.995,158.475h48.77v48.759h-48.77V158.475z M255.995,231.615 h48.77v48.769h-48.77V231.615z M182.855,158.475h48.76v48.759h-48.76V158.475z M182.855,231.615h48.76v48.769h-48.76V231.615z M109.715,158.475h48.76v48.759h-48.76V158.475z M109.715,231.615h48.76v48.769h-48.76V231.615z M85.335,353.525h-48.76v-48.759 h48.76V353.525z M85.335,280.385h-48.76v-48.769h48.76V280.385z M85.335,207.235h-48.76v-48.759h48.76V207.235z M402.285,353.525 h-292.57v-48.759h292.57V353.525z M475.425,353.525h-48.761v-48.759h48.761V353.525z M475.425,280.385h-73.14V158.475h73.14 V280.385z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardSvgrepoCom);
export default __webpack_public_path__ + "static/media/keyboard-svgrepo-com.e56049bc19df1ca335a50520c400a7d4.svg";
export { ForwardRef as ReactComponent };